"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("../index.scss");
const AdminPublisherCardEditable_1 = __importDefault(require("@Components/Cards/WorkDetailCards/AdminPublisherCards/AdminPublisherCardEditable"));
const OriginalPublisherCardEditable_1 = __importDefault(require("@Components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardEditable"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const SHARE_ERROR = 'All parties must have shares and the total shares must not exceed 100.06%';
const SHARE_ERROR_CARD = 'Value must be greater than 0%';
const PublishersShareStep = () => {
    const { workStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [errorCards, setErrorCards] = (0, react_1.useState)([]);
    const [shareError, setShareError] = (0, react_1.useState)();
    const [totalShares, setTotalShares] = (0, react_1.useState)(0);
    const resetErrors = () => {
        setErrorCards([]);
    };
    const addErrorCard = (ipId) => {
        setErrorCards([...errorCards, ipId]);
    };
    const onShareChange = () => {
        resetErrors();
        sharesCounter();
    };
    const sharesValidation = () => {
        if (totalShares > 100.06 && workStore.isOverclaimAllowed) {
            setShareError('');
        }
        else if (totalShares <= 0 || totalShares > 100.06) {
            setShareError(SHARE_ERROR_CARD);
        }
        else {
            setShareError('');
        }
    };
    const sharesCounter = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            setTotalShares(0);
            return;
        }
        let shares = 0;
        workDraftFromLocal.originalPublishers.forEach((op) => {
            shares += Number(op.publisherShare);
            if (op.administratorPublishers.length) {
                op.administratorPublishers.forEach((ap) => {
                    if (Number(ap.publisherShare) <= 0) {
                        addErrorCard(ap.ipId);
                    }
                    shares += Number(ap.publisherShare);
                });
            }
            else {
                if (Number(op.publisherShare) <= 0) {
                    addErrorCard(op.ipId);
                }
            }
        });
        setTotalShares(shares);
    };
    const setTotalKnownShares = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { totalKnownShares: totalShares });
        workStore.setWorkDraftToLocal(updatedWorkDraft);
    };
    const determineError = (ipId) => {
        if (shareError) {
            return SHARE_ERROR;
        }
        else if (errorCards.includes(ipId)) {
            return SHARE_ERROR_CARD;
        }
        else {
            return '';
        }
    };
    (0, react_1.useEffect)(() => {
        sharesValidation();
        setTotalKnownShares();
    }, [totalShares]);
    (0, react_1.useEffect)(() => {
        onShareChange();
    }, []);
    const triggerDownstreamError = () => {
        if (shareError || errorCards.length > 0) {
            if (workStore.isOverclaimAllowed && +totalShares >= 100.06) {
                workStore.setWizardStepValidation(true);
            }
            else {
                workStore.setWizardStepValidation(false);
            }
        }
        else {
            workStore.setWizardStepValidation(true);
        }
    };
    (0, react_1.useEffect)(() => {
        triggerDownstreamError();
    }, [shareError, errorCards]);
    const workDraftFromLocal = workStore.workDraftLocal;
    const currentRhId = rightsholderStore.currentRightsholderId;
    if (!workDraftFromLocal || !currentRhId) {
        return null;
    }
    const typeCreator = location.href.split('/')[7]; // HARD CODE
    const originPublishers = workDraftFromLocal.originalPublishers;
    if (!originPublishers.length) {
        if (workDraftFromLocal.id) {
            return (react_1.default.createElement(react_router_dom_1.Navigate, { to: `/rightsholder/${currentRhId}/catalog/${workDraftFromLocal.isComplete ? 'work' : 'draft'}/${workDraftFromLocal.id}/edit/publishers` }));
        }
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: `/rightsholder/${currentRhId}/create-work/manual/${typeCreator}/publishers` });
    }
    return (react_1.default.createElement("div", { className: "publishers-step add-shares-step" },
        react_1.default.createElement("div", { className: "publishers-cards-wrapper" },
            react_1.default.createElement("div", { className: "publishers-add-area" }, originPublishers.length
                ? originPublishers.map((op) => (react_1.default.createElement("div", { className: "publisher-wrapper", key: op.localId },
                    react_1.default.createElement("div", { className: "publishers-area" },
                        react_1.default.createElement("div", { className: "main-title" },
                            react_1.default.createElement("p", { className: 'bold title' },
                                "Publisher (",
                                op.publisherName ? 1 : 0,
                                ")"),
                            react_1.default.createElement("span", { className: "small bold blue-text" }, "Required")),
                        react_1.default.createElement(OriginalPublisherCardEditable_1.default, { data: op, shareError: determineError(op.ipId), onShareChange: onShareChange })),
                    react_1.default.createElement("div", { className: `publishers-area` },
                        react_1.default.createElement("div", { className: "main-title" },
                            react_1.default.createElement("p", { className: 'bold title' },
                                "Administrator (",
                                op.administratorPublishers.length,
                                ")"),
                            react_1.default.createElement("span", { className: "small bold blue-text" }, "Optional")),
                        op.administratorPublishers.length ? (op.administratorPublishers.map((ap) => (react_1.default.createElement(AdminPublisherCardEditable_1.default, { key: ap.localId, data: ap, parentOP: op, shareError: determineError(ap.ipId), onShareChange: onShareChange })))) : (react_1.default.createElement("p", { className: 'small' }, "Administrators were not added"))))))
                : null))));
};
exports.default = (0, mobx_react_1.observer)(PublishersShareStep);
